import { createBaseFeed } from "../../factory/core/createBaseFeed.js";
import "@universityofmaryland/web-builder-library";
import "@universityofmaryland/web-styles-library";
import "@universityofmaryland/web-styles-library/typography";
import "@universityofmaryland/web-utilities-library/theme";
import "@universityofmaryland/web-elements-library";
import "@universityofmaryland/web-elements-library/composite";
import "@universityofmaryland/web-elements-library/atomic";
import "@universityofmaryland/web-utilities-library/elements";
import "@universityofmaryland/web-utilities-library/network";
import { expertsDisplayStrategy } from "../../strategies/display/experts.js";
import "../../strategies/fetch/events.js";
import "../../strategies/fetch/news.js";
import { expertsFetchStrategy } from "../../strategies/fetch/experts.js";
import "../../strategies/fetch/inTheNews.js";
import { gridLayout, gridBorderLayout } from "../../strategies/layout/grid.js";
import "@universityofmaryland/web-elements-library/layout";
const expertsGrid = (props) => {
  const { isOverlay = false } = props;
  return createBaseFeed({
    ...props,
    isOverlay,
    isAligned: !isOverlay,
    fetchStrategy: expertsFetchStrategy,
    displayStrategy: expertsDisplayStrategy,
    layoutStrategy: isOverlay ? gridLayout : gridBorderLayout,
    imageConfig: (entry) => ({
      imageUrl: entry.headshot?.[0]?.url || "",
      altText: entry.middleName ? `${entry.firstName} ${entry.middleName} ${entry.lastName}` : `${entry.firstName} ${entry.lastName}`,
      linkUrl: `https://umdrightnow.umd.edu/expert/${entry.slug}`,
      linkLabel: `View profile for ${entry.firstName} ${entry.lastName}`
    })
  });
};
export {
  expertsGrid
};
//# sourceMappingURL=grid.js.map
